import { render, staticRenderFns } from "./OrderListOrder.vue?vue&type=template&id=45675685&scoped=true"
import script from "./OrderListOrder.vue?vue&type=script&lang=js"
export * from "./OrderListOrder.vue?vue&type=script&lang=js"
import style0 from "./OrderListOrder.vue?vue&type=style&index=0&id=45675685&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45675685",
  null
  
)

export default component.exports